import { z } from 'zod';
export const CLASSIFIED_CATEGORIES = [
    { id: 'transport', title: 'Транспорт', icon: 'car' },
    { id: 'property', title: 'Недвижимость', icon: 'home' },
    { id: 'jobs', title: 'Работа', icon: 'briefcase' },
    { id: 'services', title: 'Услуги', icon: 'wrench' },
    { id: 'personal', title: 'Личные вещи', icon: 'shopping-bag' },
    { id: 'electronics', title: 'Электроника', icon: 'smartphone' },
    { id: 'home', title: 'Дом и дача', icon: 'home' },
    { id: 'hobby', title: 'Хобби и отдых', icon: 'star' },
    { id: 'animals', title: 'Животные', icon: 'heart' },
    { id: 'business', title: 'Для бизнеса', icon: 'briefcase' }
];
export const classifiedCategorySchema = z.enum([
    'transport',
    'property',
    'jobs',
    'services',
    'personal',
    'electronics',
    'home',
    'hobby',
    'animals',
    'business'
]);
export const CLASSIFIED_REGIONS = [
    'Москва',
    'Санкт-Петербург',
    'Московская область',
    'Ленинградская область',
    'Республика Адыгея',
    'Республика Алтай',
    'Республика Башкортостан',
    'Республика Бурятия',
    'Республика Дагестан',
    'Республика Ингушетия',
    'Кабардино-Балкарская Республика',
    'Республика Калмыкия',
    'Карачаево-Черкесская Республика',
    'Республика Карелия',
    'Республика Коми',
    'Республика Марий Эл',
    'Республика Мордовия',
    'Республика Саха (Якутия)',
    'Республика Северная Осетия — Алания',
    'Республика Татарстан',
    'Республика Тыва',
    'Удмуртская Республика',
    'Республика Хакасия',
    'Чеченская Республика',
    'Чувашская Республика',
    'Алтайский край',
    'Забайкальский край',
    'Камчатский край',
    'Краснодарский край',
    'Красноярский край',
    'Пермский край',
    'Приморский край',
    'Ставропольский край',
    'Хабаровский край',
    'Амурская область',
    'Архангельская область',
    'Астраханская область',
    'Белгородская область',
    'Брянская область',
    'Владимирская область',
    'Волгоградская область',
    'Вологодская область',
    'Воронежская область',
    'Ивановская область',
    'Иркутская область',
    'Калининградская область',
    'Калужская область',
    'Кемеровская область',
    'Кировская область',
    'Костромская область',
    'Курганская область',
    'Курская область',
    'Липецкая область',
    'Магаданская область',
    'Мурманская область',
    'Нижегородская область',
    'Новгородская область',
    'Новосибирская область',
    'Омская область',
    'Оренбургская область',
    'Орловская область',
    'Пензенская область',
    'Псковская область',
    'Ростовская область',
    'Рязанская область',
    'Самарская область',
    'Саратовская область',
    'Сахалинская область',
    'Свердловская область',
    'Смоленская область',
    'Тамбовская область',
    'Тверская область',
    'Томская область',
    'Тульская область',
    'Тюменская область',
    'Ульяновская область',
    'Челябинская область',
    'Ярославская область',
    'Еврейская автономная область',
    'Ненецкий автономный округ',
    'Ханты-Мансийский автономный округ — Югра',
    'Чукотский автономный округ',
    'Ямало-Ненецкий автономный округ'
];
const field = (key, label, type, extra = {}) => ({ key, label, type, ...extra });
const condition = field('condition', 'Состояние', 'select', {
    options: ['Новое', 'Бывшее в употреблении'],
    required: true
});
const goods = (options) => [
    field('type', 'Тип предложения', 'select', { options, required: true }),
    condition,
    field('brand', 'Марка / производитель', 'text')
];
export const CLASSIFIED_FIELDS = {
    transport: [
        field('type', 'Вид транспорта', 'select', {
            options: [
                'Автомобиль',
                'Мотоцикл',
                'Грузовой транспорт',
                'Водный транспорт',
                'Запчасти',
                'Другое'
            ],
            required: true
        }),
        field('brand', 'Марка', 'text'),
        field('model', 'Модель', 'text'),
        field('year', 'Год выпуска', 'number', { min: 1900, max: 2100 }),
        field('mileage', 'Пробег, км', 'number', { min: 0, max: 10000000 })
    ],
    property: [
        field('type', 'Тип объекта', 'select', {
            options: ['Квартира', 'Комната', 'Дом', 'Участок', 'Гараж', 'Коммерческая недвижимость'],
            required: true
        }),
        field('deal', 'Тип сделки', 'select', {
            options: ['Продажа', 'Долгосрочная аренда', 'Посуточная аренда'],
            required: true
        }),
        field('area', 'Площадь, м²', 'number', { min: 0.1, max: 100000000, required: true }),
        field('rooms', 'Количество комнат', 'number', { min: 0, max: 100 })
    ],
    jobs: [
        field('type', 'Тип объявления', 'select', { options: ['Вакансия', 'Резюме'], required: true }),
        field('profession', 'Профессия', 'text', { required: true }),
        field('salaryMin', 'Зарплата от, ₽', 'number', { min: 0, max: 100000000 }),
        field('salaryMax', 'Зарплата до, ₽', 'number', { min: 0, max: 100000000 }),
        field('employment', 'Занятость', 'select', {
            options: ['Полная', 'Частичная', 'Проектная', 'Стажировка'],
            required: true
        }),
        field('schedule', 'График', 'select', {
            options: ['Полный день', 'Сменный', 'Гибкий', 'Удалённо', 'Вахта']
        }),
        field('experience', 'Опыт', 'select', {
            options: ['Без опыта', 'До 1 года', '1–3 года', '3–6 лет', 'Более 6 лет']
        })
    ],
    services: [
        field('type', 'Направление услуги', 'select', {
            options: [
                'Ремонт и строительство',
                'Красота и здоровье',
                'Обучение',
                'Перевозки',
                'Уборка',
                'IT и дизайн',
                'Другое'
            ],
            required: true
        }),
        field('format', 'Формат работы', 'select', {
            options: ['На месте', 'С выездом', 'Дистанционно'],
            required: true
        })
    ],
    personal: goods(['Одежда', 'Обувь', 'Аксессуары', 'Детские товары', 'Другое']),
    electronics: goods([
        'Телефоны',
        'Компьютеры',
        'Аудио и видео',
        'Фотоаппараты',
        'Бытовая техника',
        'Другое'
    ]),
    home: goods(['Мебель', 'Посуда', 'Инструменты', 'Стройматериалы', 'Сад и огород', 'Другое']),
    hobby: goods([
        'Спорт',
        'Велосипеды',
        'Книги',
        'Коллекционирование',
        'Музыкальные инструменты',
        'Другое'
    ]),
    animals: [
        field('type', 'Тип предложения', 'select', {
            options: ['Собаки', 'Кошки', 'Птицы', 'Рыбки', 'Другие животные', 'Товары для животных'],
            required: true
        }),
        field('breed', 'Порода / вид', 'text'),
        field('age', 'Возраст', 'text')
    ],
    business: goods(['Оборудование', 'Готовый бизнес', 'Материалы', 'Другое'])
};
export const classifiedAttributesSchema = z.record(z.union([z.string().trim().max(120), z.number().finite()]));
export const classifiedInputSchema = z
    .object({
    title: z.string().trim().max(100),
    description: z.string().trim().max(10000),
    category: classifiedCategorySchema,
    region: z.string().max(100),
    city: z.string().trim().max(80),
    priceMode: z.enum(['amount', 'free', 'negotiable']),
    price: z.number().finite().min(0).max(999999999999).nullable(),
    priceUnit: z.enum(['total', 'hour', 'day', 'month', 'service']),
    attributes: classifiedAttributesSchema,
    photoIds: z.array(z.string().cuid()).max(10)
})
    .strict()
    .superRefine((input, ctx) => {
    if (input.region && !CLASSIFIED_REGIONS.includes(input.region))
        ctx.addIssue({ code: 'custom', path: ['region'], message: 'Выберите регион из списка' });
    if (new Set(input.photoIds).size !== input.photoIds.length)
        ctx.addIssue({
            code: 'custom',
            path: ['photoIds'],
            message: 'Фотографии не должны повторяться'
        });
    for (const [key, value] of Object.entries(input.attributes)) {
        const definition = CLASSIFIED_FIELDS[input.category].find((item) => item.key === key);
        if (!definition ||
            (definition.type === 'number'
                ? typeof value !== 'number' ||
                    value < (definition.min ?? 0) ||
                    value > (definition.max ?? 1e12)
                : typeof value !== 'string' ||
                    (definition.options && !definition.options.includes(value))))
            ctx.addIssue({
                code: 'custom',
                path: ['attributes', key],
                message: `Проверьте поле «${definition?.label ?? key}»`
            });
    }
    if (typeof input.attributes.salaryMin === 'number' &&
        typeof input.attributes.salaryMax === 'number' &&
        input.attributes.salaryMin > input.attributes.salaryMax)
        ctx.addIssue({
            code: 'custom',
            path: ['attributes'],
            message: 'Зарплата «до» должна быть не меньше зарплаты «от»'
        });
});
export function classifiedPublishError(input) {
    if (input.title.length < 3)
        return 'Название должно содержать от 3 символов';
    if (input.description.length < 10)
        return 'Опишите предложение подробнее: от 10 символов';
    if (!input.region || input.city.length < 2)
        return 'Укажите регион и город';
    if (input.priceMode === 'amount' && (input.price === null || input.price <= 0))
        return 'Укажите цену больше нуля или выберите «Бесплатно»';
    for (const definition of CLASSIFIED_FIELDS[input.category])
        if (definition.required &&
            (input.attributes[definition.key] === undefined || input.attributes[definition.key] === ''))
            return `Заполните поле «${definition.label}»`;
    return null;
}
export const classifiedFiltersSchema = z.record(z.union([
    z.string().trim().max(120),
    z
        .object({ min: z.number().finite().optional(), max: z.number().finite().optional() })
        .strict()
        .refine((v) => v.min === undefined || v.max === undefined || v.min <= v.max, 'Неверный диапазон')
]));
export const classifiedQuerySchema = z
    .object({
    q: z.string().trim().max(150).default(''),
    category: classifiedCategorySchema.optional(),
    region: z.string().max(100).optional(),
    city: z.string().trim().max(80).optional(),
    minPrice: z.coerce.number().min(0).max(1e12).optional(),
    maxPrice: z.coerce.number().min(0).max(1e12).optional(),
    sort: z.enum(['newest', 'price_asc', 'price_desc']).default('newest'),
    scope: z.enum(['catalog', 'favorites', 'mine']).default('catalog'),
    sellerId: z.string().cuid().optional(),
    status: z.enum(['DRAFT', 'PUBLISHED', 'WITHDRAWN', 'BLOCKED']).optional(),
    cursor: z.string().cuid().optional(),
    limit: z.coerce.number().int().min(1).max(50).default(24),
    attributes: z.string().max(3000).optional()
})
    .strict()
    .refine((v) => v.minPrice === undefined || v.maxPrice === undefined || v.minPrice <= v.maxPrice, 'Неверный диапазон цены');
export const classifiedActionSchema = z
    .object({ action: z.enum(['publish', 'withdraw', 'delete']) })
    .strict();
export const classifiedReportSchema = z
    .object({
    reason: z.enum(['Мошенничество', 'Запрещённый товар', 'Неверная категория', 'Спам', 'Другое']),
    comment: z.string().trim().max(2000).default('')
})
    .strict();
export const classifiedModerationSchema = z
    .object({ action: z.enum(['block', 'restore']), reason: z.string().trim().min(3).max(500) })
    .strict();
export const CLASSIFIED_STATUS_LABELS = {
    DRAFT: 'Черновик',
    PUBLISHED: 'Опубликовано',
    WITHDRAWN: 'Снято с публикации',
    BLOCKED: 'Снято модератором',
    DELETED: 'Удалено'
};
export function classifiedPrice(input) {
    if (input.priceMode === 'free')
        return 'Бесплатно';
    if (input.priceMode === 'negotiable' || input.price === null)
        return 'Договорная';
    const suffix = {
        total: '',
        hour: ' / час',
        day: ' / день',
        month: ' / месяц',
        service: ' / услугу'
    }[input.priceUnit];
    return `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(input.price)} ₽${suffix}`;
}
//# sourceMappingURL=classifieds.js.map